<template>
    <div class="type-law">
        <!-- // 点击分页 -->
<div>
  <!-- <el-button size="small" type="primary"  @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</el-button> -->
  <!-- {{currentPage}} / {{pageCount}} -->
  <!-- <el-button size="small" type="primary"  @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</el-button> -->
</div>
<div class="content" ref="printContent">
    <!-- <vue-pdf :src="detailDate.resource_items[0].FileUrl"></vue-pdf> -->
    <!-- <pdf ref="pdf" :src="detailDate.resource_items[0].FileUrl"></pdf> -->
  <!-- <pdf
    id="myIframe"
    ref="pdfDom"
    :src="pdfSrc" 
    :page="currentPage" 
    @num-pages="pageCount=$event" 
    @page-loaded="currentPage=$event" 
    @loaded="loadPdfHandler"> 
  </pdf> -->
</div>


    </div>
</template>

<script>
// 单组件引用
// import pdf from 'vue-pdf' 
// const PDFJS = require('pdfjs-dist')
// PDFJS.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.13.216/build/pdf.worker.js'
export default{
    props: ['detailDate'],
    data() {
        return {
            pdfSrc: '', // pdf文件src
            pageCount: 0, // pdf文件总页数
            currentPage: 1, // pdf文件页码
        }
    },
    // 然后在component中进行注册
    components: {
        // pdf
    },
    mounted(){
        console.log("pdfpdfpfd-------------");
        console.log(this.detailDate);
        // 获取文件流和文件总页数 
        // async getFileInfo() {
        //     let formData = new FormData();
        //     formData.append('wjid', this.wjid)
        //     formData.append('yhid', this.userId)
        //     let res = await getFileBuffer(formData)
        //     if(res.status === 200){
                // const blob = new Blob([res.data])
                // let pageRes = await getFilePages(formData)
        //         this.pdfSrc = URL.createObjectURL(blob)
        //         this.pageCount = pageRes.data.content
        //     }else{
        //         this.$message({
        //             message: res.message,
        //             type: 'error'
        //         });
        //     }
        // },
        // const blob = new Blob([this.detailDate.resource_items[0].FileUrl])
        // this.pdfSrc = URL.createObjectURL(blob)
        // this.pdfSrc = this.detailDate.resource_items[0].FileUrl
        //获取页数
        // let loadingTask = pdf.createLoadingTask(this.detailDate.resource_items[0].FileUrl)
        // loadingTask.promise.then(pdf => {
        //     this.pageCount= pdf.numPages
        // }).catch(err => {
        //     console.error('pdf 加载失败', err);
        // })

        // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
        // changePdfPage (val) {
        //     if (val === 0 && this.currentPage > 1) {
        //         this.currentPage--
        //     }
        //     if (val === 1 && this.currentPage < this.pageCount) {
        //         this.currentPage++
        //     }
        // },

        // // pdf加载时
        // loadPdfHandler (e) {
        //     this.currentPage = 1 // 加载的时候先加载第一页
        // },
    }

}
</script>

<style scoped>
.type-law{
    width: 850px;height: 400px;
    margin: 20px auto;
    background: yellow;
}
</style>